interface MultiSelectOptionsProps<T> {
  options: T[];
  loading: boolean;
  loadingText: string;
  emptyText: string;
  getId: (item: T) => string;
  getLabel: (item: T) => string;
  getSublabel?: (item: T) => string;
  isSelected: (id: string) => boolean;
  onToggle: (item: T) => void;
}

/** Option rows for MultiSelect: loading → empty → selectable buttons. */
export const MultiSelectOptions = <T,>({
  options,
  loading,
  loadingText,
  emptyText,
  getId,
  getLabel,
  getSublabel,
  isSelected,
  onToggle,
}: MultiSelectOptionsProps<T>) => {
  if (loading) {
    return <div className="station-multiselect-loading">{loadingText}</div>;
  }
  if (options.length === 0) {
    return <div className="station-multiselect-empty">{emptyText}</div>;
  }

  return (
    <>
      {options.map((item) => {
        const id = getId(item);
        const selected = isSelected(id);
        return (
          <button
            key={id}
            type="button"
            className={`station-multiselect-option ${selected ? 'selected' : ''}`}
            onClick={() => onToggle(item)}
            role="option"
            aria-selected={selected}
          >
            <span className={`station-option-checkbox ${selected ? 'checked' : ''}`}>
              {selected && <span className="material-symbols-outlined">check</span>}
            </span>
            <span className="station-option-text">
              <span className="station-option-address">{getLabel(item)}</span>
              {getSublabel && (
                <span className="station-option-idtag">{getSublabel(item)}</span>
              )}
            </span>
          </button>
        );
      })}
    </>
  );
};

export default MultiSelectOptions;
